import { AdoptedPetPreview } from "./AdoptedPetPreview.tsx";
import { HappyTailListItem } from "./types";
import { Carousel } from "./Carousel.tsx";

export type AdoptedPetsCarouselProps = {
  items: HappyTailListItem[];
};

export function AdoptedPetsCarousel({ items }: AdoptedPetsCarouselProps) {
  const slides = items.map((item) => (
    <AdoptedPetPreview key={item.animalId} item={item} />
  ));
  return <Carousel slides={slides} />;
}
